import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "attribute_name": {
      "column": {
        "default": null,
        "name": "attribute_name",
        "null": false,
        "type": "string"
      },
      "name": "attribute_name",
      "selected_by_default": null,
      "translated": null
    },
    "body": {
      "column": {
        "default": null,
        "name": "body",
        "null": true,
        "type": "text"
      },
      "name": "body",
      "selected_by_default": null,
      "translated": null
    },
    "body_type": {
      "column": {
        "default": "plain",
        "name": "body_type",
        "null": false,
        "type": "string"
      },
      "name": "body_type",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "detected_liquid_variables": {
      "column": {
        "default": null,
        "name": "detected_liquid_variables",
        "null": true,
        "type": "text"
      },
      "name": "detected_liquid_variables",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_id": {
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": null
      },
      "name": "resource_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "parsed_content": {
      "column": null,
      "name": "parsed_content",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Content",
  "collectionKey": "contents",
  "collectionName": "contents",
  "i18nKey": "content",
  "camelizedLower": "content",
  "name": "Content",
  "nameDasherized": "content",
  "pluralName": "contents",
  "ransackable_associations": [
    {
      "className": "ContentAbsoluteContainer",
      "collectionName": "content_absolute_containers",
      "foreignKey": "content_id",
      "name": "absolute_containers",
      "macro": "has_many",
      "resource_name": "ContentAbsoluteContainer",
      "through": null
    },
    {
      "className": "Content::Audit",
      "collectionName": "content_audits",
      "foreignKey": "content_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "ContentAudit",
      "through": null
    },
    {
      "className": "Content::Audit",
      "collectionName": "content_audits",
      "foreignKey": "content_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ContentAudit",
      "through": null
    },
    {
      "className": "PageContent",
      "collectionName": "page_contents",
      "foreignKey": "resource_id",
      "name": "page_content",
      "macro": "belongs_to",
      "resource_name": "PageContent",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "resource_id",
      "name": "survey_step_element",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "TextKey",
      "collectionName": "text_keys",
      "foreignKey": "resource_id",
      "name": "text_keys",
      "macro": "has_many",
      "resource_name": "TextKey",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "attribute_name",
      "column": {
        "default": null,
        "name": "attribute_name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "body",
      "column": {
        "default": null,
        "name": "body",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "body_type",
      "column": {
        "default": "plain",
        "name": "body_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "detected_liquid_variables",
      "column": {
        "default": null,
        "name": "detected_liquid_variables",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "ContentAbsoluteContainer",
      "collectionName": "content_absolute_containers",
      "foreignKey": "content_id",
      "name": "absolute_containers",
      "macro": "has_many",
      "resource_name": "ContentAbsoluteContainer",
      "through": null
    },
    {
      "className": "TextKey",
      "collectionName": "text_keys",
      "foreignKey": "resource_id",
      "name": "text_keys",
      "macro": "has_many",
      "resource_name": "TextKey",
      "through": null
    }
  ],
  "paramKey": "content",
  "primaryKey": "id"
}

/** Frontend model for Content. */
class Content extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  attributeName() {
    return this.readAttributeUnderscore("attribute_name")
  }

  /** @returns {boolean} */
  hasAttributeName() {
    const value = this.attributeName()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  body() {
    return this.readAttributeUnderscore("body")
  }

  /** @returns {boolean} */
  hasBody() {
    const value = this.body()

    return this._isPresent(value)
  }

  /** @returns {string} */
  bodyType() {
    return this.readAttributeUnderscore("body_type")
  }

  /** @returns {boolean} */
  hasBodyType() {
    const value = this.bodyType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  detectedLiquidVariables() {
    return this.readAttributeUnderscore("detected_liquid_variables")
  }

  /** @returns {boolean} */
  hasDetectedLiquidVariables() {
    const value = this.detectedLiquidVariables()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  resourceId() {
    return this.readAttributeUnderscore("resource_id")
  }

  /** @returns {boolean} */
  hasResourceId() {
    const value = this.resourceId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  parsedContent() {
    return this.readAttributeUnderscore("parsed_content")
  }

  /** @returns {boolean} */
  hasParsedContent() {
    const value = this.parsedContent()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  load(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "load",
        primaryKey: this.primaryKey(),
        collectionName: "contents",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./content-absolute-container.js").default>} */
  absoluteContainers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContentAbsoluteContainer")

    const ransack = {}

    ransack["content_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "absolute_containers",
        model: this,
        modelName: "ContentAbsoluteContainer",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./content-absolute-container.js").default>>} */
  loadAbsoluteContainers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("ContentAbsoluteContainer")

    const ransack = {}

    ransack["content_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "absolute_containers",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./text-key.js").default>} */
  textKeys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TextKey")

    const ransack = {}

    ransack["resource_id_eq"] = this.id()
    ransack["resource_type_eq"] = "Content"

    return new Collection(
      {
        reflectionName: "text_keys",
        model: this,
        modelName: "TextKey",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./text-key.js").default>>} */
  loadTextKeys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TextKey")

    const ransack = {}

    ransack["resource_id_eq"] = this.id()
    ransack["resource_type_eq"] = "Content"

    return this._loadHasManyReflection(
      {
        reflectionName: "text_keys",
        model: this,
        modelClass
      },
      {ransack}
    )
  }
}

export default Content
